/* eslint import/no-anonymous-default-export: [2, {"allowArray": true}] */
export default  [
  {
    titulo: 'Soy sensible, soy social',
    ciudad: 'Cartagena',
    departamento: 'Bolívar',
    convocatoria: 2021, 
    imagen: 'soy-sensible-soy-social.jpg',
    institucion: 'Institución educativa de promoción social de Cartagena',
    tipoInstitucion: 'oficial urbana',
    caracteristicas: 'ofrece educación básica primaria, secundaria y media (media académica y técnica).',
    totalEstudiantes: 1991,
    equipoLider: '30',
    grados:'grados 6 a 11',
    datoExtra: 'Tiempo realización del Proyecto: Menos de un año.',
    video: 'https://www.youtube.com/embed/D0p4uITxy-M',
    introduccion: require('./contenido-historias/SoySensible').default.introduccion,
    contenido: require('./contenido-historias/SoySensible').default.contenido,
  },
  {
    titulo: '¿A  qué  huele el arte de María?',
    ciudad: 'Sincelejo',
    departamento: 'Sucre',
    convocatoria: 2021, 
    imagen: 'a-que-huele-el-arte-de-maria.jpg',
    institucion: 'Institución educativa para poblaciones especiales',
    tipoInstitucion: 'oficial urbana',
    caracteristicas: ' ofrece educación básica primaria, secundaria y media.',
    totalEstudiantes: 1431,
    equipoLider: '14 ',
    grados:'grados 8 a 11',
    datoExtra: 'Atiende población escolar con diferentes tipos de discapacidad.',
    video: 'https://www.youtube.com/embed/zASKiLjvtCk',
    introduccion: require('./contenido-historias/AQueHueleElArte').default.introduccion,
    contenido: require('./contenido-historias/AQueHueleElArte').default.contenido,
  },
  {
    titulo: 'Efim (Educación Financiera Infantil Marcelinista)',
    ciudad: 'Barranquilla',
    departamento: 'Atlántico',
    convocatoria: 2021, 
    imagen: 'efim.jpg',
    institucion: 'Institución educativa distrital madre Marcelina',
    tipoInstitucion: 'oficial urbana',
    caracteristicas: 'ofrece educación básica primaria, secundaria y media.',
    totalEstudiantes: 690,
    equipoLider: '2',
    datoExtra: 'En los hogares marcelinistas el desequilibrio económico ha sido causado por la pandemia y por la mala administración de recursos por parte de los padres de familia.',
    video: 'https://www.youtube.com/embed/ZDMsH2CBjm8',
    introduccion: require('./contenido-historias/Efim').default.introduccion,
    contenido: require('./contenido-historias/Efim').default.contenido,
  },
  {
    titulo: 'Terapias de realidad virtual, aumentada y 2D para el manejo de emociones',
    ciudad: 'Envigado',
    departamento: 'Antioquia',
    convocatoria: 2021, 
    imagen: 'terapias-de-realidad-virtual.jpg',
    institucion: 'Institución educativa comercial de Envigado',
    tipoInstitucion: 'oficial urbana',
    caracteristicas: 'ofrece educación básica primaria, secundaria y media.',
    totalEstudiantes: 2400,
    equipoLider: '76',
    grados:'grados preescolar a 11',
    datoExtra: 'Tiempo del proyecto: 1 a 3 años.',
    video: 'https://www.youtube.com/embed/ZKDrBb5q9kU',
    introduccion: require('./contenido-historias/TerapiasAR').default.introduccion,
    contenido: require('./contenido-historias/TerapiasAR').default.contenido,
  },
  {
    titulo: 'Combating covid (cc)',
    ciudad: 'Itagüí',
    departamento: 'Antioquia',
    convocatoria: 2021, 
    imagen: 'combating.jpg',
    institucion: 'Institución educativa San José de Itagüí',
    tipoInstitucion: 'oficial urbana',
    caracteristicas: 'ofrece educación básica de preescolar a media, educación de adultos y jornada única.',
    totalEstudiantes: 1551,
    equipoLider: '2',
    grados: 'grado 10',
    datoExtra: 'Tiempo del proyecto: menos de un año.',
    video: 'https://www.youtube.com/embed/AKTn13lsn1I',
    introduccion: require('./contenido-historias/CombatingCovid').default.introduccion,
    contenido: require('./contenido-historias/CombatingCovid').default.contenido,
  },
 
  {
    titulo: 'Smartplantic: procesos automatizados',
    ciudad: 'Barranquilla',
    departamento: 'Atlántico',
    convocatoria: 2021, 
    imagen: 'smartplantic.jpg',
    institucion: 'Institución educativa distrital El Campito',
    tipoInstitucion: 'oficial urbana',
    caracteristicas: 'ofrece educación básica primaria, secundaria y media.',
    totalEstudiantes: 932,
    equipoLider: '10',
    datoExtra: 'Los aires acondicionados de la institución desechan agua que se va acumulando en charcos y fomentan la contaminación.',
    video: 'https://www.youtube.com/embed/6PvTvQpjzU8',
    introduccion: require('./contenido-historias/Smartplantic').default.introduccion,
    contenido: require('./contenido-historias/Smartplantic').default.contenido,
  },
  {
    titulo: 'Empledesepan',
    ciudad: 'Buenaventura',
    departamento: 'Valle del Cauca',
    convocatoria: 2021, 
    imagen: 'empledesepan.jpg',
    institucion: 'Institución educativa San Rafael',
    tipoInstitucion: 'oficial urbana',
    caracteristicas: 'ofrece educación básica primaria, secundaria y media.',
    totalEstudiantes: 975,
    equipoLider: '5',
    grados:'grados 8 y 9',
    datoExtra: 'El 90% de las familias tienen dificultades económicas. La institución está ubicada en un sector comercial con tiendas y supermercados alrededor.',
    introduccion: require('./contenido-historias/Empledesepan').default.introduccion,
    contenido: require('./contenido-historias/Empledesepan').default.contenido,
  },
  {
    titulo: 'La energía solar y eólica como fuentes energéticas renovables alternativas',
    ciudad: 'Almaguer',
    departamento: 'Cauca',
    convocatoria: 2021, 
    imagen: 'la-energia-solar.jpg',
    institucion: 'Institución educativa La Herradura',
    tipoInstitucion: 'Oficial rural',
    caracteristicas: 'ofrece educación básica de preescolar a media.',
    totalEstudiantes: 249,
    equipoLider: '32',
    datoExtra: 'Ubicada en el corregimiento de la Herradura, zona de conflicto armado y delincuencia. Sede educación Media.',
    video : 'https://www.youtube.com/embed/92BuUY7bllw',
    introduccion: require('./contenido-historias/LaEnergiaSolarYEolica').default.introduccion,
    contenido: require('./contenido-historias/LaEnergiaSolarYEolica').default.contenido,
  },

]